import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function solutionamj() {
  return (
    <section className="solution_amj p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Solutions Delivered</h2>
            <p>
              Rodeo Social successfully delivered a centralized platform,
              streamlining collaboration within teams. The app serves as a hub,
              simplifying content contribution, scheduling, and approval
              processes for enhanced efficiency.
            </p>
            <p>
              The app provides businesses with a seamless content creation,
              scheduling, and posting solution. Rodeo Social's user-friendly
              interface ensures easy upload, scheduling, and approval of social
              media content, simplifying the overall content management workflow
            </p>
            <p>
              All in all, Rodeo Social introduced dynamic gamification elements,
              effectively motivating team members. The app strikes a precise
              balance, encouraging active contribution and healthy competition
              while ensuring that the primary focus on effective social media
              management is maintained. The result is a dynamic and engaging
              social media strategy for businesses.
            </p>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/rodeo/solution.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={857}
              height={662}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default solutionamj;
